import React from "react";
import { useTranslation } from "react-i18next";

const cookieTable = [
  // Example cookies, update as needed for your real usage
  { name: "cookieConsent", provider: "This site", purpose: "Stores your cookie preferences", duration: "1 year", type: "Strictly Necessary" },
  { name: "_ga", provider: "Google Analytics", purpose: "Analytics and site usage tracking", duration: "2 years", type: "Performance & Analytics" },
  { name: "_fbp", provider: "Facebook", purpose: "Advertising and retargeting", duration: "3 months", type: "Marketing" },
];

const CookiePolicyPage = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto py-10 px-6 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">{t('cookie_policy')}</h1>
      <p className="mb-6">{t('cookie_policy_intro')}</p>
      <h2 className="text-2xl font-semibold mt-8 mb-4">{t('cookie_types_title')}</h2>
      <ul className="mb-8 space-y-4">
        <li><strong>{t('cookie_essential')}</strong>: {t('cookie_essential_desc')}</li>
        <li><strong>{t('cookie_performance')}</strong>: {t('cookie_performance_desc')}</li>
        <li><strong>{t('cookie_functional')}</strong>: {t('cookie_functional_desc')}</li>
        <li><strong>{t('cookie_marketing')}</strong>: {t('cookie_marketing_desc')}</li>
        <li><strong>{t('cookie_third_party')}</strong>: {t('cookie_third_party_desc')}</li>
      </ul>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_table_title')}</h2>
      <p className="mb-4">{t('cookie_table_intro')}</p>
      <div className="overflow-x-auto mb-8">
        <table className="min-w-full border text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-2 py-1">{t('cookie_table_name')}</th>
              <th className="border px-2 py-1">{t('cookie_table_provider')}</th>
              <th className="border px-2 py-1">{t('cookie_table_purpose')}</th>
              <th className="border px-2 py-1">{t('cookie_table_duration')}</th>
              <th className="border px-2 py-1">{t('cookie_table_type')}</th>
            </tr>
          </thead>
          <tbody>
            {cookieTable.map((row, i) => (
              <tr key={i}>
                <td className="border px-2 py-1">{row.name}</td>
                <td className="border px-2 py-1">{row.provider}</td>
                <td className="border px-2 py-1">{row.purpose}</td>
                <td className="border px-2 py-1">{row.duration}</td>
                <td className="border px-2 py-1">{row.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_manage')}</h2>
      <p className="mb-4">{t('cookie_withdraw_consent')}</p>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_rights_gdpr')}</h2>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_rights_ccpa')}</h2>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_data_transfers')}</h2>
      <h2 className="text-xl font-semibold mb-2">{t('cookie_policy_jurisdiction')}</h2>
      <p className="text-sm text-gray-500 mt-8">{t('cookie_policy_updated')}</p>
      <p className="text-sm text-gray-500 mt-2">{t('cookie_contact_info')}</p>
    </div>
  );
};

export default CookiePolicyPage;
